import React from "react";
import { Link } from "react-router-dom";

const DataDeletion = () => {
  return (
    <div
      style={{
        padding: "40px 20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.6",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {/* --- Header --- */}
      <header
        style={{
          marginBottom: "40px",
          borderBottom: "1px solid #eee",
          paddingBottom: "20px",
        }}
      >
        <Link
          to="/"
          style={{
            textDecoration: "none",
            color: "#005397",
            fontWeight: "600",
          }}
        >
          &larr; Back to Home
        </Link>
        <h1 style={{ color: "#005397", marginTop: "10px" }}>
          Privacy & Data Management
        </h1>
        <p>
          At Rental Highway, we allow you to control your personal information.
          You can request to delete your entire account or specific data
          associated with it.
        </p>
      </header>

      {/* --- SECTION 1: DELETE ACCOUNT --- */}
      <section id="account" style={{ marginBottom: "60px" }}>
        <h2
          style={{
            color: "#FF9800",
            borderLeft: "4px solid #FF9800",
            paddingLeft: "10px",
          }}
        >
          1. Request Your Account Deletion
        </h2>
        <p>
          If you wish to delete your Rental Highway account permanently, this
          will remove your login credentials and all associated data (listings,
          chat history, and preferences).
        </p>

        <div
          style={{
            background: "#fff8e1",
            padding: "20px",
            borderRadius: "8px",
            marginTop: "15px",
            border: "1px solid #eee",
          }}
        >
          <strong>To delete your account:</strong>
          <ol style={{ marginLeft: "20px", marginTop: "10px" }}>
            <li>
              Send an email to <strong>support@rentalhighway.com</strong>
            </li>
            <li>
              Subject Line: <strong>Permanent Account Deletion Request</strong>
            </li>
            <li>
              Include your registered <strong>email address</strong> and full
              name.
            </li>
          </ol>
          <p style={{ fontSize: "0.9rem", color: "#666", marginTop: "10px" }}>
            * Your account will be deactivated immediately upon verification,
            and data will be permanently wiped within 30 days.
          </p>
        </div>
      </section>

      {/* --- SECTION 2: DELETE DATA --- */}
      <section id="data">
        <h2
          style={{
            color: "#FF9800",
            borderLeft: "4px solid #FF9800",
            paddingLeft: "10px",
          }}
        >
          2. Request Specific Data Deletion
        </h2>
        <p>
          If you wish to keep your account active but delete specific historical
          data (such as old property listings, specific chat logs, or search
          history), you may request a partial data wipe.
        </p>

        <div
          style={{
            background: "#fff8e1",
            padding: "20px",
            borderRadius: "8px",
            marginTop: "15px",
            border: "1px solid #ffe0b2",
          }}
        >
          <strong>To delete specific data:</strong>
          <ol style={{ marginLeft: "20px", marginTop: "10px" }}>
            <li>
              Send an email to <strong>social@rentalhighway.com</strong>
            </li>
            <li>
              Subject Line:{" "}
              <strong>Data Deletion Request (Keep Account)</strong>
            </li>
            <li>
              Specify exactly which data you want us to remove (e.g., "Delete my
              listings from 2023").
            </li>
          </ol>
          <p style={{ fontSize: "0.9rem", color: "#666", marginTop: "10px" }}>
            * We will process specific data removal requests within 30 days
            while keeping your main account active.
          </p>
        </div>
      </section>

      <footer
        style={{
          marginTop: "60px",
          fontSize: "0.8rem",
          color: "#999",
          textAlign: "center",
        }}
      >
        &copy; {new Date().getFullYear()} Rental Highway. All rights reserved.
      </footer>
    </div>
  );
};

export default DataDeletion;
